(function () {
  function forEachNode(list, callback) {
    Array.prototype.forEach.call(list || [], callback);
  }

  function getSectionRoots() {
    return document.querySelectorAll('[id^="shopify-section-"]');
  }

  function decodeB64(b64) {
    if (!b64) return '';
    try {
      return atob(b64);
    } catch (e) {
      try {
        return atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
      } catch (e2) {
        return '';
      }
    }
  }

  function initObfuscatedLinks(sectionRoot) {
    if (!sectionRoot) return;

    var nodes = sectionRoot.querySelectorAll('.sidebar-obf-img[data-ob-direction], .promo-obf-img[data-ob-direction]');

    forEachNode(nodes, function (el) {
      if (el.dataset.obfReady === 'true') return;

      var url = decodeB64(el.getAttribute('data-ob-direction'));
      if (!url) return;

      var defaultNewTab = el.getAttribute('data-ob-newtab') === 'true';

      function go(forceNewTab) {
        var openInNewTab = forceNewTab || defaultNewTab;
        if (openInNewTab) {
          window.open(url, '_blank', 'noopener');
        } else {
          window.location.assign(url);
        }
      }

      el.addEventListener('click', function (e) {
        go(e.ctrlKey || e.metaKey);
      });

      el.addEventListener('auxclick', function (e) {
        if (e.button === 1) {
          e.preventDefault();
          go(true);
        }
      });

      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go(false);
        }
      });

      el.dataset.obfReady = 'true';
    });
  }

  function syncTopPromoLink(sectionRoot) {
    if (!sectionRoot) return;

    var link = sectionRoot.querySelector('.promo-top-native-link');
    if (!link) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var desktopUrl = link.getAttribute('data-url-dk') || '';
    var mobileUrl = link.getAttribute('data-url-mb') || '';
    var activeUrl = isMobile ? mobileUrl : desktopUrl;

    if (!activeUrl) {
      link.removeAttribute('href');
      link.style.pointerEvents = 'none';
      link.setAttribute('aria-disabled', 'true');
      return;
    }

    link.setAttribute('href', activeUrl);
    link.style.pointerEvents = '';
    link.removeAttribute('aria-disabled');

    if (link.getAttribute('data-open-new-window') === 'true') {
      link.setAttribute('target', '_blank');
    } else {
      link.removeAttribute('target');
    }
  }

    function getSummaryOffsetValue() {
    var header = document.querySelector('.header-box');
    if (header && header.classList.contains('fixed-nav')) {
      return header.offsetHeight + 30;
    }
    return 30;
  }

  function getSummaryOffset() {
    return getSummaryOffsetValue() + 'px';
  }

  function getAbsoluteTop(el) {
    return window.pageYOffset + el.getBoundingClientRect().top;
  }

  function primeSummaryMedia(articleText, target) {
    var currentTop = window.pageYOffset;
    var targetTop = getAbsoluteTop(target);
    var minTop = Math.max(0, Math.min(currentTop, targetTop) - 300);
    var maxTop = Math.max(currentTop, targetTop) + window.innerHeight * 1.5;
    var watched = [];

    var media = articleText.querySelectorAll('img, iframe, video');

    Array.prototype.forEach.call(media, function (el) {
      var elTop = getAbsoluteTop(el);
      if (elTop < minTop || elTop > maxTop) return;

      watched.push(el);

      if (el.tagName === 'IMG') {
        if (el.loading === 'lazy') {
          el.loading = 'eager';
        }

        if (el.dataset) {
          if (
            el.dataset.src &&
            (
              !el.getAttribute('src') ||
              /^data:image\/gif;base64/i.test(el.getAttribute('src'))
            )
          ) {
            el.setAttribute('src', el.dataset.src);
          }

          if (el.dataset.srcset && !el.getAttribute('srcset')) {
            el.setAttribute('srcset', el.dataset.srcset);
          }

          if (
            el.dataset.sizes &&
            (
              !el.getAttribute('sizes') ||
              el.getAttribute('sizes') === 'auto'
            )
          ) {
            el.setAttribute('sizes', el.dataset.sizes);
          }
        }
      } else if (el.tagName === 'VIDEO') {
        el.preload = 'auto';
      }
    });

    return watched;
  }

  function scrollSummaryTargetPrecisely(target, articleText, hash) {
    var cleaned = false;
    var cleanupFns = [];
    var offset = getSummaryOffsetValue();

    function wantedTop() {
      return Math.max(0, Math.round(getAbsoluteTop(target) - offset));
    }

    function snap() {
      if (cleaned) return;

      window.scrollTo({
        top: wantedTop(),
        behavior: 'auto'
      });
    }

    function addAutoCleanup(timeoutId) {
      cleanupFns.push(function () {
        clearTimeout(timeoutId);
      });
    }

    function bindOnce(el, eventName) {
      var handler = function () {
        setTimeout(snap, 0);
      };

      el.addEventListener(eventName, handler, { once: true });
      cleanupFns.push(function () {
        el.removeEventListener(eventName, handler);
      });
    }

    var watchedMedia = primeSummaryMedia(articleText, target);

    Array.prototype.forEach.call(watchedMedia, function (el) {
      if (el.tagName === 'IMG' || el.tagName === 'IFRAME') {
        bindOnce(el, 'load');
      } else if (el.tagName === 'VIDEO') {
        bindOnce(el, 'loadeddata');
      }
    });

    window.scrollTo({
      top: wantedTop(),
      behavior: 'smooth'
    });

    var t1 = setTimeout(snap, 180);
    var t2 = setTimeout(snap, 450);
    var t3 = setTimeout(snap, 900);
    var t4 = setTimeout(function () {
  snap();
  if (hash) {
    history.replaceState(null, '', hash);
  }
}, 1400);

    addAutoCleanup(t1);
    addAutoCleanup(t2);
    addAutoCleanup(t3);
    addAutoCleanup(t4);

    return function () {
      if (cleaned) return;
      cleaned = true;

      Array.prototype.forEach.call(cleanupFns, function (fn) {
        fn();
      });
    };
  }

  function initArticleSummary(sectionRoot) {
    if (!sectionRoot) return;

    var article = sectionRoot.querySelector('.article-template-idm');
    var summary = sectionRoot.querySelector('.article-summary');
    var articleText = sectionRoot.querySelector('.article-text');
    var nav = sectionRoot.querySelector('.article-summary-content');
    var button = sectionRoot.querySelector('.show-summary');
    var label = sectionRoot.querySelector('.show-summary-label');

    if (!article || !summary || !articleText || !nav || !button || !label) return;

    var links = nav.querySelectorAll('a[href^="#"]');
    if (!links.length) {
      summary.classList.add('hide');
      return;
    }

    summary.classList.remove('hide');

    var articleShow = article.getAttribute('data-summary-show') || 'Afficher';
    var articleHide = article.getAttribute('data-summary-hide') || 'Masquer';
    var scrollMarginTop = getSummaryOffset();
    var cancelPendingSummaryScroll = null;

    Array.prototype.forEach.call(
      articleText.querySelectorAll('h2[id], h3[id]'),
      function (heading) {
        heading.style.scrollMarginTop = scrollMarginTop;
      }
    );

    if (!nav.dataset.summaryLinksBound) {
      nav.addEventListener('click', function (event) {
        var clicked = event.target;
        if (!clicked || typeof clicked.closest !== 'function') return;

        var link = clicked.closest('a[href^="#"]');
        if (!link) return;

        var hash = link.getAttribute('href');
        var target = sectionRoot.querySelector(hash) || document.querySelector(hash);
        if (!target) return;

        event.preventDefault();

        if (typeof cancelPendingSummaryScroll === 'function') {
  cancelPendingSummaryScroll();
  cancelPendingSummaryScroll = null;
}

cancelPendingSummaryScroll = scrollSummaryTargetPrecisely(target, articleText, hash);
      });

      nav.dataset.summaryLinksBound = 'true';
    }

    if (!button.dataset.summaryBound) {
      button.addEventListener('click', function () {
        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isExpanded));
        label.textContent = isExpanded ? articleShow : articleHide;
        nav.classList.toggle('hide', isExpanded);
      });

      button.dataset.summaryBound = 'true';
    }

    button.setAttribute('aria-expanded', 'false');
    label.textContent = articleShow;
    nav.classList.add('hide');
  }

  function initFilteredCommentsPagination(sectionRoot) {
    if (!sectionRoot) return;

    var commentsSection = sectionRoot.querySelector('#article-comments');
    var paginationRoot = sectionRoot.querySelector('#article-comments-pagination');
    var paginationBlock = paginationRoot ? paginationRoot.querySelector('.pagination-block') : null;

    if (!commentsSection || !paginationRoot || !paginationBlock) return;
    if (paginationRoot.dataset.paginationReady === 'true') return;

    var entries = Array.prototype.slice.call(sectionRoot.querySelectorAll('#article-comments [data-comment-entry]'));
    var perPage = parseInt(paginationRoot.getAttribute('data-comments-per-page'), 10) || 50;
    var labelPrev = paginationRoot.getAttribute('data-label-prev') || '';
    var labelNext = paginationRoot.getAttribute('data-label-next') || '';
    var labelPage = paginationRoot.getAttribute('data-label-page') || '';
    var totalEntries = entries.length;
    var totalPages = Math.ceil(totalEntries / perPage);

    paginationRoot.dataset.paginationReady = 'true';

    if (totalEntries <= perPage) {
      paginationRoot.style.display = 'none';
      return;
    }

    function getCurrentPage() {
      var url = new URL(window.location.href);
      var page = parseInt(url.searchParams.get('cpage'), 10);

      if (!page || page < 1) return 1;
      if (page > totalPages) return totalPages;
      return page;
    }

    function updateUrl(page, pushState) {
      var url = new URL(window.location.href);

      if (page <= 1) {
        url.searchParams.delete('cpage');
      } else {
        url.searchParams.set('cpage', String(page));
      }

      url.hash = 'article-comments';

      if (pushState) {
        window.history.pushState({ cpage: page }, '', url.toString());
      } else {
        window.history.replaceState({ cpage: page }, '', url.toString());
      }
    }

    function renderEntries(page) {
      var start = (page - 1) * perPage;
      var end = start + perPage;

      entries.forEach(function (entry, index) {
        entry.style.display = (index >= start && index < end) ? '' : 'none';
      });
    }

    function buildPageLink(label, page, options) {
      options = options || {};
      var isActive = !!options.active;
      var extraClass = options.extraClass || '';
      var rel = options.rel || '';

      if (isActive) {
        var span = document.createElement('span');
        span.className = 'pagination-number pagination-active' + (extraClass ? ' ' + extraClass : '');
        span.textContent = label;
        span.setAttribute('aria-current', 'page');
        span.setAttribute('aria-label', 'Page ' + label);
        return span;
      }

      var link = document.createElement('a');
      link.href = '#article-comments';
      link.className = 'pagination-number' + (extraClass ? ' ' + extraClass : '');
      link.textContent = label;

      if (rel) {
        link.setAttribute('rel', rel);
      }

      if (options.ariaLabel) {
        link.setAttribute('aria-label', options.ariaLabel);
      }

      link.addEventListener('click', function (event) {
        event.preventDefault();
        setPage(page, true, true);
      });

      return link;
    }

    function renderPagination(currentPage) {
      paginationBlock.innerHTML = '';

      if (currentPage > 1) {
        paginationBlock.appendChild(
          buildPageLink('‹', currentPage - 1, {
            rel: 'prev',
            extraClass: 'pagination-number-arrow',
            ariaLabel: labelPrev
          })
        );
      }

      for (var i = 1; i <= totalPages; i++) {
        paginationBlock.appendChild(
          buildPageLink(String(i), i, {
            active: i === currentPage,
            ariaLabel: labelPage ? labelPage.replace('__N__', String(i)) : ''
          })
        );
      }

      if (currentPage < totalPages) {
        paginationBlock.appendChild(
          buildPageLink('›', currentPage + 1, {
            rel: 'next',
            extraClass: 'pagination-number-arrow',
            ariaLabel: labelNext
          })
        );
      }
    }

    function setPage(page, pushState, scrollToComments) {
      if (page < 1) page = 1;
      if (page > totalPages) page = totalPages;

      renderEntries(page);
      renderPagination(page);
      if (pushState) {
        updateUrl(page, true);
      }

      if (scrollToComments) {
        window.scrollTo({
  top: Math.max(0, Math.round(getAbsoluteTop(commentsSection) - getSummaryOffsetValue())),
  behavior: 'smooth'
});
      }
    }

    window.addEventListener('popstate', function () {
      setPage(getCurrentPage(), false, false);
    });

    setPage(getCurrentPage(), false, false);
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function isWide() {
    return window.matchMedia('(min-width: 1400px)').matches;
  }

  function getStickyTop() {
    var header = document.querySelector('.header-box');
    var baseGap = isWide() ? 20 : 10;

    if (header && header.classList.contains('fixed-nav')) {
      return Math.ceil(header.getBoundingClientRect().height) + baseGap;
    }

    return baseGap;
  }

  function initStickySidebar(sectionRoot) {
    if (!sectionRoot) return;

    var wrap = sectionRoot.querySelector('.article-sidebar .sidebar-sticky-fit');
    var inner = sectionRoot.querySelector('.article-sidebar .sidebar-sticky-fit-inner');

    if (!wrap || !inner) return;
    if (wrap.dataset.stickyReady === 'true') return;

    function apply() {
      if (!isDesktop()) {
        wrap.style.position = '';
        wrap.style.top = '';
        inner.style.setProperty('--sb-scale', 1);
        inner.style.width = '';
        return;
      }

      wrap.style.position = 'sticky';

      var top = getStickyTop();
      sectionRoot.style.setProperty('--sb-top', top + 'px');

      var bottomGap = isWide() ? 20 : 10;
      var safeBottom = 14;
      var available = window.innerHeight - top - bottomGap - safeBottom;

      if (available <= 0) return;

      inner.style.setProperty('--sb-scale', 1);

      requestAnimationFrame(function () {
        var rect = inner.getBoundingClientRect();
        var h = rect.height || 0;
        if (!h) return;

        var scale = 1;
        if (h > available) scale = available / h;

        inner.style.setProperty('--sb-scale', scale.toFixed(4));
      });
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(apply);
      ro.observe(inner);
    }

    window.addEventListener('resize', apply, { passive: true });
    apply();

    wrap.dataset.stickyReady = 'true';
  }

  var PRIMARY_COMMENT_LANG = 'fr';
  var _postedCommentUrlCleaned = false;

  function scrollToPostedComment(commentId) {
    function resolveTarget() {
      var section = document.getElementById('article-comments');
      var el = commentId ? document.getElementById('comment-' + commentId) : null;

      if (el && section && section.querySelector('[data-comment-entry]') === el) return section;
      if (el) return el;
      if (section) return section;

      return document.getElementById('new-comment');
    }

    function measure() {
      var el = resolveTarget();
      if (!el) return null;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return Math.min(max, Math.max(0, Math.round(getAbsoluteTop(el) - getSummaryOffsetValue())));
    }

    if (!resolveTarget()) return;

    var cancelled = false;
    function cancel() { cancelled = true; }

    window.addEventListener('wheel', cancel, { passive: true, once: true });
    window.addEventListener('touchstart', cancel, { passive: true, once: true });
    window.addEventListener('keydown', cancel, { once: true });

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !window.requestAnimationFrame) {
      var flat = measure();
      if (flat !== null) window.scrollTo({ top: flat, behavior: 'auto' });
      return;
    }

    var start = window.pageYOffset;
    var startTime = null;

    function step(now) {
      if (cancelled) return;
      if (startTime === null) startTime = now;

      var target = measure();
      if (target === null) return;

      var progress = Math.min(1, (now - startTime) / 700);
      var eased = 1 - Math.pow(1 - progress, 3);

      window.scrollTo({ top: Math.round(start + (target - start) * eased), behavior: 'auto' });

      if (progress < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function cleanPostedCommentUrl() {
    if (_postedCommentUrlCleaned) return;
    _postedCommentUrlCleaned = true;

    var postedId = '';

    try {
      var url = new URL(window.location.href);
      postedId = url.searchParams.get('comment') || '';

      if (postedId) {
        url.searchParams.delete('comment');
        window.history.replaceState(window.history.state, '', url.toString());
      }
    } catch (e) {}

    if (postedId) scrollToPostedComment(postedId);
  }

  function getCommentLangCode() {
    var lang = document.documentElement.getAttribute('lang') || '';
    lang = lang.split('-')[0].trim().toLowerCase();
    return /^[a-z]{2,3}$/.test(lang) ? lang : '';
  }

  function initCommentForm(sectionRoot) {
    if (!sectionRoot) return;

    var form = sectionRoot.querySelector('form#new-comment');
    if (!form || form.dataset.commentFormReady === 'true') return;
    form.dataset.commentFormReady = 'true';

    var field = form.querySelector('textarea.new-comment-content');
    var button = form.querySelector('button[type="submit"]');
    var idleLabel = button ? button.textContent : '';
    var releaseTimer;

    form.addEventListener('submit', function () {
      var lang = getCommentLangCode();

      if (field && lang && lang !== PRIMARY_COMMENT_LANG) {
        var carrier = form.querySelector('input[data-comment-body-carrier]');

        if (!carrier) {
          carrier = document.createElement('input');
          carrier.type = 'hidden';
          carrier.setAttribute('data-comment-body-carrier', '');
          form.appendChild(carrier);
        }

        carrier.name = 'comment[body]';
        carrier.value = String(field.value).replace(/\s+$/, '') + ' [[idm:' + lang + ']]';
        field.removeAttribute('name');
      }

      if (button) {
        clearTimeout(releaseTimer);

        setTimeout(function () {
          button.disabled = true;
          button.style.opacity = '0.6';
          button.style.cursor = 'wait';
          button.textContent = idleLabel + '…';
        }, 0);

        releaseTimer = setTimeout(function () {
          button.disabled = false;
          button.style.opacity = '';
          button.style.cursor = '';
          button.textContent = idleLabel;

          if (field && !field.getAttribute('name')) {
            field.setAttribute('name', 'comment[body]');
          }
        }, 12000);
      }
    }, true);
  }

  function initSection(sectionRoot) {
    if (!sectionRoot) return;

    initObfuscatedLinks(sectionRoot);
    syncTopPromoLink(sectionRoot);
    initArticleSummary(sectionRoot);
    initFilteredCommentsPagination(sectionRoot);
    initCommentForm(sectionRoot);
    initStickySidebar(sectionRoot);
  }

  function initAll() {
    cleanPostedCommentUrl();

    forEachNode(getSectionRoots(), function (sectionRoot) {
      initSection(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  var _resizeSyncTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_resizeSyncTimer);
    _resizeSyncTimer = setTimeout(function () {
      forEachNode(getSectionRoots(), function (sectionRoot) {
        syncTopPromoLink(sectionRoot);
      });
    }, 150);
  }, { passive: true });
})();